import { createSelector } from '@ngrx/store';
import { cartPopupState } from '../root';

export const isCartPopupVisible = createSelector(cartPopupState, (cartPopup) => cartPopup.isVisible);
